import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {default as PromocionesListado} from '../../components/Promociones'
import { sagaGetPromociones,
sagaEliminarPromocion,
sagaImagenPromociones,
sagaEliminarImagenPromociones,
sagaSaveImagenPromociones, } from '../../reducers/promocionesReducer/actions'
import { promosSelector, imageSelector } from '../../selectors/promocionesSelector'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'

function Money(n) {
    var c = 2,
      d = ",",
      t = ".",
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  };

class PromocionesContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            openModalImagen:false,
            imagenOriginal: undefined,
            imagen: undefined,
            idTemportal: Math.floor(Math.random()*10000),
            openModal: false,
            openModalConfirmar:false,
            openModalConfirm: false,
            botonOk: "",
            handleOk: "",
            handleOnCloseConfirmacion: ()=>{this.setState({openModalConfirm:false})}
        }
        // busco los datos iniciales
        this.busqueda()
        this.props.sagaImagenPromociones()
    }

    componentWillReceiveProps(nextProps){

        this.setState({
            imagen: nextProps.media.imagen,
            imagenOriginal: nextProps.media.imagenOriginal,
            imagenSinRecorte: nextProps.media.imagenOriginal,
            currentFile: (nextProps.media.imagenOriginalRaw!==null && nextProps.media.imagenOriginalRaw!=="")?nextProps.media.imagenOriginalRaw:undefined,
            imagenSinRecorteRaw: (nextProps.media.imagenOriginalRaw!==null && nextProps.media.imagenOriginalRaw!=="")?nextProps.media.imagenOriginalRaw:undefined
        },()=>{this.render()})
        
    }

    onRecorteImagenCompressed = (currentFile) => {
       
        // guardo el recorte
        let payload = {currentFile: currentFile, originalFile: this.state.imagenSinRecorteRaw ,idTemporal: this.state.idTemporal, original: false}
        this.props.sagaSaveImagenPromociones(payload)   
        

        // genero el image source
        let recorte = URL.createObjectURL(currentFile)

        // actualizo el catálogo      
        this.setState({
            imagen:recorte,
            openModalImagen: false,
        })
    }

    handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
        
        // obtengo el nombre de archivo. Si se trata de edicion voy al state catalogo.

        let fileName = this.state.currentFile.name;
        if (fileName === undefined) fileName = "blob";
        
        // comprimo la imagen
        let newSize = calculateNewSize(imageData.width, imageData.height, 600, 750)//600 1200
        this.setState({imagenSinRecorte: this.state.imagenOriginal, imagenSinRecorteRaw: this.state.currentFile})
        compress(blobData, fileName, newSize.width, newSize.height, this.onRecorteImagenCompressed)
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {
        
        
        if (rejectedFiles.length !== 0){
            if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.")
            if (rejectedFiles.length > 1) Notification.showError("Se permite una única imagen descriptiva de la promoción.")

        }
        else{
            if (acceptedFiles.length !== 0) {
                //let currentFile = acceptedFiles[0]
                
                let currentFile = acceptedFiles[0]

                let _self = this
                let img = new Image()

                img.onload = function(){
                    let newSize = calculateNewSize(this.width, this.height, 750*2, (937.5)*2) //*4 para aumentar la calidad
                    
                    //comprimo la imagen a una dimension manejable
                    compress(currentFile, currentFile.name, newSize.width, newSize.height, (imageCompressed)=>{
                        
                        let file = URL.createObjectURL(imageCompressed)
                        
                        //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
                        let newImgSrc = {Path: currentFile.name, selected: false, idArticuloImagenes:0, Orden: 1, Miniatura: true, PathImagen: file}    
                        _self.setState({
                            openModalImagen:true,
                            imagenOriginal: newImgSrc.PathImagen,
                            currentFile: imageCompressed
                        })
                    })
                }

                
            img.src = URL.createObjectURL(currentFile)

               /* 
                //guardo en el estado una copia, para usarla al momento de guardar los recortes
                let currentFileCopy = currentFile
                let file = URL.createObjectURL(currentFile)
            
                
                let payload = {currentFile: currentFile,idTemporal: this.state.idTemporal, original: true}
                //this.props.sagaSaveImagenRubro(payload)          
                
                //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
                let newImgSrc = {Path: currentFile.name, selected: false, idArticuloImagenes:0, Orden: 1, Miniatura: true, PathImagen: file}    
                
                this.setState({
                    imagenOriginal: newImgSrc.PathImagen,
                    currentFile: currentFileCopy,
                    openModalImagen:true
                })
*/
            }
        }                
    }

    
    handleOnCloseCropperModal = () => {
        this.setState({openModalImagen:false})
    }

    handleOnOpenCropperModal = () => {
        this.setState({
            imagenOriginal: this.state.imagenSinRecorte,
            currentFile: this.state.imagenSinRecorteRaw},
            ()=>{this.setState({openModalImagen:true})}
        )
    }


    busqueda(){
        this.props.sagaGetPromociones();
    }

    handleFiltro = (e)=>{
    }

    render() {
        return <PromocionesListado 
        {...this.state}
        promociones={this.props.data.promociones}
        mapToItem={(x)=>({
            nombre:x.nombre, 
            descripcion:(x.limiteSuperior!==0)?("$"+Money(x.limiteInferior) + " y $" + Money(x.limiteSuperior)):("Superior a $" + Money(x.limiteInferior)), 
            descripcion2:x.porcentajeDescuento,
            activo: x.activo,
            onClick: (x.activo && x.habilitado)?()=>{ this.props.history.push("/Promociones/Edit/"+x.id) }:undefined,
            opciones:
            [
                {nombre:"Editar",handler:()=>{this.props.history.push("/Promociones/Edit/"+x.id) }},
                {nombre:"Eliminar",handler:()=>{this.setState({openModalConfirm:true,botonOk:"Eliminar", mensajeConfirmacion:`Está por borrar la promoción ${x.nombre}` , handleOk:()=>{this.props.sagaEliminarPromocion(x.id);}})}},
            ]})}
        
        handleOnCloseCropperModal={this.handleOnCloseCropperModal}
        handleOnOpenCropperModal={this.handleOnOpenCropperModal}
        handleOnDropFile = {this.handleOnDropFile}
        handleOnSaveImagenCortada={this.handleOnSaveImagenCortada}
        handleEliminarImagen={this.props.sagaEliminarImagenPromociones}
        handleOnPagination={()=>{this.busqueda()}}
    />
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        sagaGetPromociones,
        sagaEliminarPromocion,
        sagaImagenPromociones,
        sagaEliminarImagenPromociones,
        sagaSaveImagenPromociones,
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        data: promosSelector(state),
        media:imageSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PromocionesContainer)